import { useQuery } from "@tanstack/react-query";
import { getSettings } from "../../api/apiSettings";
import i18next from "i18next";

export function useGetSettings() {

    const {
        isLoading,
        data: Settings,
        error,
    } = useQuery({
        queryKey: ["settings", i18next.language],
        queryFn: () => getSettings(),
        retry: false,
    });

    return { isLoading, error, Settings };
}
